module.exports = __webpack_public_path__ + "media/images/webpage/instagram/index-top-6b2e7a96846948ab82410988c8d871b0.webp";